export enum EnumZonaBalance {
  ESP = 1,
  ITA = 2,
  FRA = 3,
  Internacional = 4,
  PT = 5,
  NLD = 6,
  GBR = 7,
  DZA = 8
}
